import englishMessages from 'ra-language-english';
import polyglotI18nProvider from 'ra-i18n-polyglot';

const customEnglishMessages = {
    ...englishMessages,
    cards: {
        delete: {
            not_found: 'Card not found',
            generic_error: 'Something went wrong when deleting the card'
        }
    }
};

const messages = {
    'en': customEnglishMessages,
};

export const i18nProvider = polyglotI18nProvider(locale => messages[locale]);